import cx from 'classnames';
import { useContext } from 'react';

import { CartContext } from '../../contexts/cart.context';
import { formatViewNumber } from '../../utils/utils';
import './checkout-item.styles.scss';

const CheckoutItem = ({ cartItem, isDelivery }) => {
  const { name, imageUrl, price, quantity, prices } = cartItem;

  const { clearItemFromCart, addItemToCart, removeItemToCart } =
    useContext(CartContext);

  // Les fleurs se vendent en plusieurs conditionnements : celui retenu est le seul
  // dont le prix correspond à celui posé dans le panier.
  const florLabel = prices?.find((item) => item.value === price)?.label;

  const clearItemHandler = () => clearItemFromCart(cartItem);
  const addItemHandler = () => addItemToCart(cartItem);
  const removeItemHandler = () => removeItemToCart(cartItem);

  return (
    <div
      className={cx('checkout-item-container', { 'is-delivery': isDelivery })}
    >
      <div className="image-container">
        <img src={imageUrl} alt={`${name}`} />
      </div>

      <span className="name-label">
        <span className="name"> {name} </span>
        {prices && <span className="label"> {florLabel} </span>}
      </span>

      <span className="quantity">
        {isDelivery ? (
          <span className="quantity-text">Qté:</span>
        ) : (
          <button
            type="button"
            className="arrow"
            onClick={removeItemHandler}
            aria-label={`Retirer un ${name}`}
          >
            &#10094;
          </button>
        )}
        <span className="value">{quantity}</span>
        {!isDelivery && (
          <button
            type="button"
            className="arrow"
            onClick={addItemHandler}
            aria-label={`Ajouter un ${name}`}
          >
            &#10095;
          </button>
        )}
      </span>

      <span className="price"> {formatViewNumber(price)} €</span>

      {!isDelivery && (
        <button
          type="button"
          className="remove-button"
          onClick={clearItemHandler}
          aria-label={`Retirer ${name} du panier`}
        >
          &#10005;
        </button>
      )}
    </div>
  );
};

export default CheckoutItem;
